import React from 'react';

var AvatarIcon = function AvatarIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "icon_person"), /*#__PURE__*/React.createElement("g", {
    id: "\u9875\u9762-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\u79FB\u52A8\u7AEF-\u4E0A\u6ED1\u540E",
    transform: "translate(-251.000000, -112.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\u5BFC\u822A",
    transform: "translate(8.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "person\u5907\u4EFD",
    transform: "translate(243.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,3 C15.3137085,3 18,5.6862915 18,9 C18,10.9589865 17.061169,12.6986973 15.6088912,13.7937482 C17.9164148,14.7755499 19.3365188,16.8595881 19.8699781,20.0458623 C19.8870613,20.1478983 19.9063362,20.2777873 19.9278028,20.4355293 C19.9648216,20.7091791 19.7729287,20.9609759 19.4992693,20.9979235 C19.4774999,21.0008626 19.4555606,21.002364 19.4335937,21.0024192 L18.4335938,21.0024192 C18.1849576,21.0031761 17.9735396,20.8211246 17.9378034,20.5750685 C17.9024654,20.3438004 17.871213,20.1615261 17.8440462,20.0282457 C17.1698788,16.7207729 15.2177233,15.0670365 11.9875796,15.0670365 C8.76247921,15.0670365 6.81827901,16.7156129 6.15497899,20.0127656 C6.12743276,20.1496933 6.09587225,20.3376802 6.06029746,20.5767263 C6.02349313,20.8209719 5.81392934,21.0018332 5.56692708,21.0024192 L4.56812827,21.0024192 C4.29198732,21.0015312 4.06884865,20.7769569 4.0697341,20.500816 C4.06980236,20.4795267 4.07123026,20.4582636 4.07427863,20.4371918 C4.09638107,20.2744173 4.11621472,20.140695 4.13377958,20.0360247 C4.66755812,16.8552005 6.08654708,14.7744113 8.39074643,13.7936572 C6.93883099,12.6986973 6,10.9589865 6,9 C6,5.6862915 8.6862915,3 12,3 Z M12,5 C9.790861,5 8,6.790861 8,9 C8,11.209139 9.790861,13 12,13 C14.209139,13 16,11.209139 16,9 C16,6.790861 14.209139,5 12,5 Z",
    id: "\u5F62\u72B6\u7ED3\u5408",
    fill: "#091221"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\u77E9\u5F62",
    fill: "#D8D8D8",
    opacity: "0",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }))))));
};

export { AvatarIcon as default };
